import roles from './roles';

const {
  administrator,
  delegation,
  story_brand,
  story_dealer,
  spec_brand,
  spec_dealer,
  moderation,
  installs,
  can_errors,
  mileage,
  tradein,
  areas,
  dealers_areas,
  upload_exhibition_data,
  russified_cars,
} = roles;

export default {
  accounts: [administrator, delegation],
  carErrors: [can_errors],
  stories: [story_brand, story_dealer],
  offers: [spec_brand, spec_dealer],
  mileage: [mileage],
  installs: [installs],
  moderation: [moderation],
  tradein: [tradein],
  areas: [areas],
  dealersAreas: [dealers_areas],
  uploadExhibitionData: [upload_exhibition_data],
  russifiedCars: [russified_cars],
};
